import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true, // Enables the use of custom CSS variables
    },
    themes: {
      light: {
        primary: "#F4F7FC", // Body / heading text
        secondary: "#E8B84B", // Accent — times, prices, eyebrow
        accent: "#E8B84B",
        onBackground: "#F4F7FC", // Default font color
        background: "#0B1D3A", // Default background color
      },
    },
  },
});

export default vuetify;
